import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { ProgramaService } from '../../../services/formulacion/programa.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
declare var toastr;

@Component({
  selector: 'app-programa',
  templateUrl: './programa.component.html',
  styleUrls: [],
  providers: [ProgramaService]
})
export class ProgramaComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  dataResourcePR: any[];
  model: any = {
    id: 0,
    codigo: '',
    descripcion: '',
    es_habilitado: true
  };
  fuenteId: number;
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  state_toogle: boolean = false;
  vigencia: any[];
  baseUrl = environment.apiEndpoint;
  hasError: any;

  constructor(private _ps: ProgramaService) {
    this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];
    this.clearErrors();
    this.getProgramas();
  }

  ngOnInit() {
  }

  clearErrors() {
    this.hasError = { codigo: false, descripcion: false };
  }

  getProgramas() {
    this._ps.getPrograma().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourcePR = result.data;
        } else {
          this.dataResourcePR = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  showModalAdd() {
    this.clearErrors();
    this.model.id = 0;
    this.model.codigo = '';
    this.model.descripcion = '';
    this.model.es_habilitado = true;
    this.state_toogle = false;
    this.popupVisibleAdd = true;
  }

  showModalEdit(data: any) {
    this.clearErrors();
    this.model.id = data.id;
    this.model.codigo = data.codigo;
    this.model.descripcion = data.descripcion;
    this.model.es_habilitado = data.es_habilitado;
    this.state_toogle = true;
    this.popupVisibleAdd = true;
  }

  savePrograma() {
    this.hasError = { codigo: false, descripcion: false };
    if (this.validate(this.model)) {
      if (this.model.id == 0) {
        this._ps.postPrograma(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getProgramas();
              this.popupVisibleAdd = false;
              toastr.success('Programa adicionado exitosamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
      else {
        this._ps.putPrograma(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getProgramas();
              this.popupVisibleAdd = false;
              toastr.success('Programa modificado exitosamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
    }
  }

  showModalDelete(id: number) {
    this.fuenteId = id;
    this.popupVisibleDel = true;
  }

  deletePrograma() {
    this._ps.deletePrograma(this.fuenteId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getProgramas();
          this.popupVisibleDel = false;          
          toastr.success('Proceso realizado correctamente.');          
        } else {              
          toastr.warning(result.data);   
        }
      },
      error => { console.log('Error', error); });
  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.codigo, 'text')) {
      this.hasError.codigo = true; res = false;
    }
    if (!UtilHelper.validator(data.descripcion, 'text')) {
      this.hasError.descripcion = true; res = false;
    }
    return res;
  }
}
